import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ArchiveSourcePreview from './ArchiveSourcePreview';
import { TECH_ARCHIVES, GROWTH_ARCHIVES } from '../lib/archiveFeeds';

function ExternalArchiveSection({
  disclaimer,
  techTabLabel = 'Tech Archives',
  growthTabLabel = 'Learning Journey',
  showTitle = false,
  title = 'Archives',
  kicker,
}) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('tech');
  const [activePhase, setActivePhase] = useState(0);

  const archives = activeTab === 'tech' ? TECH_ARCHIVES : GROWTH_ARCHIVES;
  const activeSource = archives[activePhase] ?? archives[0];

  const handleTab = (tab) => {
    setActiveTab(tab);
    setActivePhase(0);
  };

  return (
    <>
      <div className="archive-header">
        <div className="archive-title-area">
          {kicker && <span className="section-kicker">{kicker}</span>}
          {showTitle && <h2 className="section-title">{title}</h2>}
          {disclaimer && <p className="archive-disclaimer">{disclaimer}</p>}
        </div>
        <div className="archive-tabs">
          <button
            type="button"
            className={`tab-btn ${activeTab === 'tech' ? 'is-active' : ''}`}
            onClick={() => handleTab('tech')}
          >
            {techTabLabel}
          </button>
          <button
            type="button"
            className={`tab-btn ${activeTab === 'growth' ? 'is-active' : ''}`}
            onClick={() => handleTab('growth')}
          >
            {growthTabLabel}
          </button>
        </div>
      </div>

      <div className="archive-phase-tabs" role="tablist" aria-label="Archive phases">
        {archives.map((source, idx) => (
          <button
            key={source.url}
            type="button"
            role="tab"
            aria-selected={activePhase === idx}
            className={`phase-btn ${activePhase === idx ? 'is-active' : ''}`}
            onClick={() => setActivePhase(idx)}
          >
            {source.title}
          </button>
        ))}
      </div>

      <div className="archive-content archive-preview-panel" key={`${activeTab}-${activePhase}`}>
        <ArchiveSourcePreview
          source={activeSource}
          visitLabel={t('me.newTabLink', { defaultValue: '새 창에서 보기 →' })}
        />
      </div>
    </>
  );
}

export default ExternalArchiveSection;
